webpackJsonp([6,0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(235);
	module.exports = __webpack_require__(234);


/***/ },

/***/ 1:
/***/ function(module, exports, __webpack_require__) {

	var config = {
	  scheme: 'release',
	  env: {
	    alpha: {
	      prefix: ''
	    },
	    beta: {
	      prefix: '/admin',
	      apiPath: '/apiPath',
	      basicUrl: 'http://dev.lvyuetravel.com:8080',
	      aihuazhuUrl: 'http://test.www.aihuazhu.com',
	      imagesUrl: 'http://test.static.lvyuetravel.com/www/zh/static/images/',
	      senCondjs: 'http://dev.lvyuetravel.com:8080/static/sensorsdata.min.js',
	      senCond: 'https://shence.lvyuetravel.com/sa?project=default'
	    },
	    devx: {
	      prefix: '',
	      apiPath: '',
	      basicUrl: 'http://dev.www.lvyuetravel.com',
	      aihuazhuUrl: 'http://dev.www.aihuazhu.com',
	      imagesUrl: 'http://dev.static.lvyuetravel.com/www/zh/static/images/',
	      senCondjs: 'http://dev.static.lvyuetravel.com/www/zh/static/sensorsdata.min.js',
	      senCond: 'https://shence.lvyuetravel.com/sa?project=default'
	    },
	    test: {
	      prefix: '',
	      apiPath: '',
	      basicUrl: 'http://test.www.lvyuetravel.com',
	      aihuazhuUrl: 'http://test.www.aihuazhu.com',
	      imagesUrl: 'http://test.static.lvyuetravel.com/www/zh/static/images/',
	      senCondjs: 'http://test.static.lvyuetravel.com/www/zh/static/sensorsdata.min.js',
	      senCond: 'https://shence.lvyuetravel.com/sa?project=default'
	    },
	    integrate: {
	      prefix: '',
	      apiPath: '',
	      basicUrl: 'http://www.integrate.lvyuetravel.com',
	      aihuazhuUrl: 'http://www.integrate.aihuazhu.com',
	      imagesUrl: 'http://static.integrate.lvyuetravel.com/www/zh/static/images/',
	      senCondjs: 'http://static.integrate.lvyuetravel.com/www/zh/static/sensorsdata.min.js',
	      senCond: 'https://shence.lvyuetravel.com/sa?project=default'
	    },
	    production: {
	      prefix: '',
	      apiPath: '',
	      basicUrl: 'https://www.lvyuetravel.com',
	      aihuazhuUrl: 'https://www.aihuazhu.com',
	      imagesUrl: 'https://static.lvyuetravel.com/www/zh/static/images/',
	      senCondjs: 'https://static.lvyuetravel.com/www/zh/static/sensorsdata.min.js',
	      senCond: 'https://shence.lvyuetravel.com/sa?project=production'
	    }
	  },
	  domains: {
	    urlStatic: '',
	    loginSite: 'http://test.www.lvyuetravel.com'
	  }
	};
	
	// 环境切换
	if (false) {
	  config.scheme = 'beta';
	} else if (false) {
	  config.scheme = 'devx';
	} else if (false) {
	  config.scheme = 'test';
	} else if (false) {
	  config.scheme = 'integrate';
	} else if (true) {
	  config.scheme = 'production';
	}
	module.exports = config;

/***/ },

/***/ 2:
/***/ function(module, exports) {

	var language = 'zh-CN';
	if (window.location.search.indexOf('locale=USA') > -1) {
	  language = 'USA';
	  localStorage.setItem('language', language);
	} else if (window.location.search.indexOf('locale=en') > -1) {
	  language = 'USA';
	  localStorage.setItem('language', language);
	} else if (window.location.search.indexOf('locale=JP') > -1) {
	  language = 'JP';
	  localStorage.setItem('language', language);
	} else if (window.location.search.indexOf('locale=KO') > -1) {
	  language = 'KO';
	  localStorage.setItem('language', language);
	} else if (window.location.search.indexOf('locale=TH') > -1) {
	  language = 'TH';
	  localStorage.setItem('language', language);
	} else if (window.location.search.indexOf('locale=zh-CN') > -1) {
	  language = 'zh-CN';
	  localStorage.setItem('language', language);
	} else if (window.location.search.indexOf('locale=YH') > -1) {
	  language = 'YH';
	  localStorage.setItem('language', language);
	} else {
	  localStorage.setItem('language', language);
	}
	
	module.exports = { language: language };

/***/ },

/***/ 3:
/***/ function(module, exports, __webpack_require__) {

	
	
	var config = __webpack_require__(1);
	config = config.env[config.scheme];
	// var xecond= config.env[config.scheme].senCond
	(function (para) {
	  //神策
	  var p = para.sdk_url,
	      n = para.name,
	      w = window,
	      d = document,
	      s = 'script',
	      x = null,
	      y = null;
	  w['sensorsDataAnalytic201505'] = n;
	  w[n] = w[n] || function (a) {
	    return function () {
	      (w[n]._q = w[n]._q || []).push([a, arguments]);
	    };
	  };
	  var ifs = ['track', 'quick', 'register', 'registerPage', 'registerOnce', 'clearAllRegister', 'trackSignup', 'trackAbtest', 'setProfile', 'setOnceProfile', 'appendProfile', 'incrementProfile', 'deleteProfile', 'unsetProfile', 'identify', 'login', 'logout', 'trackLink', 'clearAllRegister'];
	  for (var i = 0; i < ifs.length; i++) {
	    w[n][ifs[i]] = w[n].call(null, ifs[i]);
	  }
	  if (!w[n]._t) {
	    x = d.createElement(s), y = d.getElementsByTagName(s)[0];
	    x.async = 1;
	    x.src = p;
	    w[n].para = para;
	    y.parentNode.insertBefore(x, y);
	  }
	})({
	  sdk_url: config.senCondjs,
	  name: 'sensors',
	  server_url: config.senCond,
	  // server_url:' http://shence.lvyuetravel.com:8107',
	  cross_subdomain: true,
	  heatmap: {
	    //是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
	    clickmap: 'default',
	    //是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
	    scroll_notice_map: 'not_collect'
	  }
	});
	sensors.registerPage({ platformType: 'pc' });
	sensors.quick('autoTrack'); //神策系统必须是1.4最新版及以上

/***/ },

/***/ 4:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 5:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 6:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 7:
/***/ function(module, exports, __webpack_require__) {

	//预搜索
	window.destinationInitVal = $('input[name="regionName"]').val(); //为使用预搜索失去焦点时使用
	var Config = __webpack_require__(1);
	var apiPath = Config.env[Config.scheme].apiPath;
	var aihuazhuUrl = Config.env[Config.scheme].aihuazhuUrl;
	__webpack_require__(3);
	function preSearch(date, clickDestinationCallback, brandSeries) {
	  $(document).on('click.closeDest', function (e) {
	    var $this = $('.pre-search');
	    //有匹配的城市或景点显示匹配的第一个，没有则显示默认的
	    var locations = $('.pre-search .locations');
	    if (locations.length) {
	      destinationInitVal = locations.eq(0).data('locations');
	      var obj = {
	        name: locations.eq(0).data('locations'),
	        id: locations.eq(0).data('cityid'),
	        type: locations.eq(0).data('type')
	      };
	      clickDestinationCallback(obj);
	    }
	
	    $('input[name="regionName"]').val(destinationInitVal);
	    if ($this.find($(e.target)).length > 0 || $this[0] === e.target) return;
	    setTimeout(function () {
	      $('.pre-search').remove();
	    }, 30);
	  });
	  var bind_name = 'input';
	  if (navigator.userAgent.indexOf("MSIE") != -1) {
	    bind_name = 'propertychange';
	  }
	  $('input[name="regionName"]').bind(bind_name, function () {
	    var inputVal = $(this).val();
	    if (!inputVal.length) {
	      $('.hot-city-model').hide();
	      $('.pre-search').remove();
	      return false;
	    }
	
	    var ajaxUrl,
	        data = {
	      param: inputVal,
	      checkIn: date.checkIn,
	      pn: 1,
	      checkOut: date.checkOut,
	      ps: 50
	    };
	
	    if (brandSeries) {
	      ajaxUrl = apiPath + '/api/hotel/pre_brand_search.json';
	      data.brandSeries = brandSeries;
	    } else {
	      ajaxUrl = apiPath + '/api/hotel/pre_search.json';
	    }
	    $.ajax({
	      //版本号
	      headers: {
	        ver: 206
	      },
	      url: ajaxUrl,
	      type: 'GET',
	      cache: false,
	      data: data,
	      success: function (res) {
	        $('.hot-city-model').hide();
	
	        if (res.success) {
	          var backHtmlWrap = '<ul class="pre-search" style="top:' + ($('.destination').outerHeight() + 2) + 'px"></ul>';
	          var preSearchDiv = $('.pre-search');
	          preSearchDiv.length ? preSearchDiv.show() : $('.destination').append(backHtmlWrap);
	
	          var backHtml = '';
	          if (res.total == 0) {
	            backHtml += '<p>很抱歉没有搜索到匹配结果，换个词试试</p>';
	          } else {
	            for (var i = 0; i < res.data.locations.length; i++) {
	              var item = res.data.locations[i];
	              if (item.type == 2) {
	                //城市
	                backHtml += '<li class="locations locationsCity" data-locations="' + item.cityName + '" data-type="' + item.type + '" data-cityid="' + item.city + '"><span>' + item.highlightCityName + ',' + item.provinceName + '</span><span>城市</span></li>';
	              }
	              if (item.type == 3) {
	                //景点
	                backHtml += '<li class="locations locationsSpot" data-locations="' + item.cityName + '" data-type="' + item.type + '" data-landmarkid="' + item.landmarkId + '" data-land="' + item.landmarkName + '"><span>' + item.highlightLandmark + ',' + item.provinceName + '</span><span>景点</span></li>';
	              }
	            }
	            for (var i = 0; i < res.data.hotels.length; i++) {
	              var item = res.data.hotels[i];
	              backHtml += '<li class="hotels"><a href="javascript:void(0);" data-id="' + item.id + '">' + (item.highlightName || item.name) + '</a><span>酒店</span></li>';
	            }
	          }
	          $('.pre-search').html(backHtml);
	
	          $('.pre-search').find('a').click(function () {
	            window.open(aihuazhuUrl + '/detail/' + $(this).data('id'));
	          });
	          //点击城市
	          $('.pre-search').find('.locationsCity').click(function () {
	            setTimeout(function () {
	              $('.pre-search').remove();
	            }, 0);
	            var obj = {
	              name: $(this).data('locations'),
	              id: $(this).data('cityid'),
	              type: $(this).data('type')
	            };
	            clickDestinationCallback(obj);
	          });
	          //点击景点
	          $('.pre-search').find('.locationsSpot').click(function () {
	            setTimeout(function () {
	              $('.pre-search').remove();
	            }, 0);
	            var obj = {
	              name: $(this).data('land'),
	              id: $(this).data('landmarkid'),
	              type: $(this).data('type')
	            };
	
	            clickDestinationCallback(obj);
	          });
	        } else {}
	      }
	    });
	  });
	}
	
	exports.preSearch = preSearch;

/***/ },

/***/ 234:
/***/ function(module, exports, __webpack_require__) {

	// var languageType = require('./languageCommon.js')
	__webpack_require__(2);
	var language = localStorage.getItem('language') || 'zh-CN';
	__webpack_require__(4);
	__webpack_require__(6);
	__webpack_require__(5);
	__webpack_require__(3);
	var preS = __webpack_require__(7);
	var preSearch = preS.preSearch;
	var Config = __webpack_require__(1);
	var apiPath = Config.env[Config.scheme].apiPath;
	var aihuazhuUrl = Config.env[Config.scheme].aihuazhuUrl;
	
	if (language == 'zh-CN') {
	    $('body').removeClass('en');
	} else {
	    $('body').addClass('en');
	}
	$('.language').on('mouseover', function () {
	    $(".choicelanguage").show();
	}).on('mouseout', function () {
	    $(".choicelanguage").hide();
	});
	$('.choicelanguage a').eq(0).on('click', function () {
	    console.log(window.location);
	    window.location.href = window.location.origin + window.location.pathname + '?locale=zh-CN';
	    localStorage.setItem('language', 'zh-CN');
	    //window.location.reload();
	});
	$('.choicelanguage a').eq(1).on('click', function () {
	    localStorage.setItem('language', 'USA');
	    window.location.href = window.location.origin + window.location.pathname + '?locale=USA';
	    //window.location.reload();
	});
	$('.choicelanguage a').eq(2).on('click', function () {
	    localStorage.setItem('language', 'JP');
	    window.location.href = window.location.origin + window.location.pathname + '?locale=JP';
	    //window.location.reload();
	});
	$('.choicelanguage a').eq(3).on('click', function () {
	    localStorage.setItem('language', 'KO');
	    window.location.href = window.location.origin + window.location.pathname + '?locale=KO';
	    //window.location.reload();
	});
	$('.choicelanguage a').eq(4).on('click', function () {
	    localStorage.setItem('language', 'TH');
	    window.location.href = window.location.origin + window.location.pathname + '?locale=TH';
	    //window.location.reload();
	});
	$('.choicelanguage a').eq(5).on('click', function () {
	    localStorage.setItem('language', 'TH');
	    window.location.href = window.location.origin + window.location.pathname + '?locale=YH';
	    //window.location.reload();
	});
	$('.brand').addClass('select');
	$('.reservation').css('color', 'white');
	var flagIndex = 0;
	$('.reservationCode .close ,.reservationCode .guanbi').on('click', function () {
	    $('.reservationCode').fadeOut(300);
	    $('.reservation').css('opacity', 1);
	});
	
	$(".about1").on('mouseover', function () {
	    $(".aboutLv").show();
	});
	$(".about1").on('mouseout', function () {
	    $(".aboutLv").hide();
	});
	$(".brand1").on('mouseover', function () {
	    $(".choiceBrand").show();
	}).on('mouseout', function () {
	    $(".choiceBrand").hide();
	});
	$('.submitInfo_input_1').on('click', function () {
	    $('.select_forJoinUs').slideToggle();
	});
	$('.select_forJoinUs span').on('click', function () {
	    $('.submitInfo_input_joinUs').html($(this).html());
	});
	var width = document.documentElement.offsetWidth;
	if (width > 1920) {
	    width = 1920;
	}
	var width1 = $('.simply_container_header').width();
	flagIndex = width1 - width;
	
	$('.simply_container_header_conainer div').css({ width: width });
	$('.simply_container_header_conainer').css({ width: 7 * width });
	$(window).resize(function () {
	    //当浏览器大小变化时
	    width1 = $('.simply_container_header').width();
	    flagIndex = width1 - width;
	});
	
	var step = 1;
	var $headerContainer = $('.simply_container_header_conainer');
	var timer = setInterval(move, 4000);
	var moveflag = 0;
	moveflag = -flagIndex / 2;
	$headerContainer.css({ 'left': -width - moveflag });
	function move(n) {
	    moveflag = -flagIndex / 2;
	    step++;
	    n != undefined ? step = n : null;
	    if (step == 6) {
	        $headerContainer.css('left', -width - moveflag);
	        step = 2;
	    }
	    $('.simply_banner li').eq(step - 1).addClass('simply_banner_select').siblings().removeClass('simply_banner_select');
	    if (step == 5) {
	        $('.simply_banner li').eq(0).addClass('simply_banner_select').siblings().removeClass('simply_banner_select');
	    }
	    $headerContainer.stop(false, true).animate({ left: -step * width - moveflag }, 2500, 'linear', function () {});
	}
	$('.simply_container_header').on('mouseover', function () {
	    clearInterval(timer);
	});
	$('.simply_container_header').on('mouseout', function () {
	    timer = setInterval(move, 3500);
	});
	$('.simply_banner li').on('click', function () {
	    step = $('.simply_banner li').index($(this)) + 1;
	    $('.simply_banner li').eq(step - 1).addClass('simply_banner_select').siblings().removeClass('simply_banner_select');
	    $headerContainer.stop(false, true).css({ left: -step * width + -moveflag });
	});
	
	var $oImgs = $('.flowerBuilding_info_slider div');
	function flowerMove(index) {
	    $oImgs.eq(index).fadeIn(800).siblings().fadeOut(800);
	}
	$('.flowerBuilding_info_').on('click', function () {
	    var width = parseFloat($('.flowerBuilding_info').width());
	    var index1 = null;
	    for (var j = 0; j < 4; j++) {
	        var string2 = '.flowerBuilding_info_' + (j + 1);
	        if ($(string2).css('display') == "none") {
	            index1 = j;
	        }
	    }
	    var index = $('.flowerBuilding_info_').index($(this));
	    if (index1 - index == 1) {
	        $('.flowerBuilding_info_').eq(index1).css({ left: parseInt($(this).css('left')) + 100 });
	    } else if (index1 - index == -1) {
	        $('.flowerBuilding_info_').eq(index1).css({ left: parseInt($(this).css('left')) - 100 });
	    }
	    flowerMove(index);
	    $(this).hide().siblings().show();
	    if (parseFloat($(this).css("left")) > 300 || isNaN(parseFloat($(this).css("left")))) {
	        for (var i = 0; i < index + 1; i++) {
	            var string = '.flowerBuilding_info_' + (i + 1);
	            $(string).animate({ left: 100 * i }, 500);
	        }
	        for (var k = 3; k > index; k--) {
	            var string1 = '.flowerBuilding_info_' + (k + 1);
	            $(string1).animate({ left: width - 100 * (4 - k) }, 500);
	        }
	    } else {
	        for (var i = 0; i < index + 1; i++) {
	            var string = '.flowerBuilding_info_' + (i + 1);
	            $(string).animate({ left: 100 * i }, 500);
	        }
	        for (var k = 3; k >= index; k--) {
	            var string1 = '.flowerBuilding_info_' + (k + 1);
	            $(string1).animate({ left: width - 100 * (4 - k) }, 500);
	        }
	    }
	
	    $('.flowerBuilding_info_big').eq(index).siblings().slideUp();
	    setTimeout(function () {
	        $('.flowerBuilding_info_big').eq(index).slideDown();
	    }, 800);
	});
	$("img").on('dragstart', function () {
	    return false;
	});
	
	$(function () {
	    $.ajax({
	        url: apiPath + '/api/hotel/brand_hot_cities.json',
	        type: 'GET',
	        cache: false,
	        data: {
	            client: 'app',
	            brandSeries: 120
	        },
	        success: function (res) {
	            if (res.success) {
	                window.hotCityObj = res.data;
	                destination('inland');
	            }
	        }
	    });
	    preSearch({
	        checkIn: $('input[data-selector="checkIn"]').val(),
	        checkOut: $('input[data-selector="checkOut"]').val()
	    }, clickDestinationCallback, 120);
	});
	
	// 目的地 弹窗
	function destination(key) {
	    $('[data-selector="destination"]').destination({
	        data: hotCityObj,
	        key: key,
	        hot: false,
	        mapKey: ['ABCD', 'EFGH', 'JKLM', 'NOPQRS', 'TUVWX', 'YZ'],
	        clickCallBack: function (obj) {
	            clickDestinationCallback(obj);
	        }
	    });
	}
	
	function clickDestinationCallback(obj) {
	    $('[name="regionId"]').val(obj.id);
	    $('[name="regionName"]').val(obj.name);
	    $('input[name="regionType"]').val(obj.type);
	    destinationInitVal = obj.name; //默认显示的目的地的值
	    var timeObj = getTime(obj.id, true, hotCityObj);
	    setDatepickInit(timeObj);
	    $('input[name="scenic-spot"]').val('');
	    $('input[name="descId"]').val('');
	}
	
	$(document).on('submit', '[data-selector="search-hotel"]', function () {
	    var cityId = $('input[name="regionId"]').val();
	    var regionType = $('input[name="regionType"]').val();
	    var startDay = $('input[data-selector="checkIn"]').val();
	    var endDay = $('input[data-selector="checkOut"]').val();
	    window.open(aihuazhuUrl + '/list/' + regionType + '/' + cityId + '?startDay=' + startDay + '&endDay=' + endDay + '&brand=' + 120);
	    return false;
	});

/***/ },

/***/ 235:
/***/ function(module, exports, __webpack_require__) {

	// var languageType = require('./languageCommon.js')
	var languageType = __webpack_require__(2);
	var language = localStorage.getItem('language') || 'zh-CN';
	
	if (language == 'zh-CN') {
	    document.getElementsByTagName('meta')[1].setAttribute('content', Vylukmeta[language]);
	    document.getElementsByTagName('meta')[2].setAttribute('content', Vylukkey[language]);
	    document.title = Vyluktitle[language];
	} else {
	    document.getElementsByTagName('meta')[1].setAttribute('content', Vylukmeta['USA']);
	    document.getElementsByTagName('meta')[2].setAttribute('content', Vylukkey['USA']);
	    document.title = Vyluktitle['USA'];
	    // document.getElementsByTagName('title')[1].setAttribute('content',grouptitle['USA'])
	}
	$('.commonlanguage').html(commonlanguage[language]);
	$('title').html(WeiLaiTitle[language]);
	$('.commonHomePage').html(commonHomePage[language]);
	$('.commonLvyue').html(commonLvyue[language]);
	$('.commonAboutLvyue').html(commonAboutLvyue[language]);
	$('.commonlvyueBrand').html(commonlvyueBrand[language]);
	$('.commonFlowerConstruction').html(commonFlowerConstruction[language]);
	$('.commonFloralLux').html(commonFloralLux[language]);
	$('.commonClaim').html(commonClaim[language]);
	$('.commonWeiLai').html(commonWeiLai[language]);
	$('.commonTanChen').html(commonTanChen[language]);
	$('.commonJoinInCooperation').html(commonJoinInCooperation[language]);
	$('.commonPanorama').html(commonPanorama[language]);
	// $('.commonPaidInformation').html(commonPaidInformation[language]);
	$('.commonZh').html(commonZh[language]);
	$('.commonUsa').html(commonUsa[language]);
	$('.commonJp').html(commonJp[language]);
	$('.commonKo').html(commonKo[language]);
	$('.commonTh').html(commonTh[language]);
	$('.commonYh').html(commonYh[language]);
	$('.commonflowerTravel').html(commonflowerTravel[language]);
	$('.commonReservations a').html(commonReservations[language]);
	$('.commonClose').html(commonClose[language]);
	$('.commonFreebooking').html(commonFreebooking[language]);
	$('.commonDownload').html(commonDownload[language]);
	$('.commonWechatSubscription').html(commonWechatSubscription[language]);
	$('.commonHuazhuSubscription').html(commonHuazhuSubscription[language]);
	$('.commonBrandintroductio').html(commonBrandintroductio[language]);
	$('.commonWantJoin').html(commonWantJoin[language]);
	$('.commonConectUs').html(commonConectUs[language]);
	$('.commonCustomerServiceHotline').html(commonCustomerServiceHotline[language]);
	$('.commonConectChina').html(commonCustomerServiceHotlineChina[language]);
	$('.commonConectPhilippines').html(commonCustomerServiceHotlinePhilippines[language]);
	$('.commonConectJapan').html(commonCustomerServiceHotlineJapan[language]);
	$('.commonConectKorea').html(commonCustomerServiceHotlineKorea[language]);
	$('.commonConectThailand').html(commonCustomerServiceHotlineThailand[language]);
	$('.commonConectYh').html(commonCustomerServiceHotlineYh[language]);
	$('.commonCompanyInfo').html(commonCompanyInfo[language]);
	$('.commonCompanyBeianInfo').html(commonCompanyBeianInfo[language]);
	$('.commonCompanyBeianText').html(commonCompanyBeianText[language]);
	$('.commonCompanyLicense').html(commonCompanyLicense[language]);
	$('.commonCompanyICP').html(commonCompanyICP[language]);
	$('.WeiLaiDesign').html(WeiLaiDesign[language]);
	$('.WeiLaiDesignType1').html(WeiLaiDesignType1[language]);
	$('.WeiLaiDesignType2').html(WeiLaiDesignType2[language]);
	$('.WeiLaiDesignType3').html(WeiLaiDesignType3[language]);
	$('.WeiLaiBrandIntroductionTitle').html(WeiLaiBrandIntroductionTitle[language]);
	$('.WeiLaiBrandIntroductionInfo').html(WeiLaiBrandIntroductionInfo[language]);
	$('.WeiLaiCorevalueTitle').html(WeiLaiCorevalueTitle[language]);
	$('.WeiLaiCorevalueIntroduction').html(WeiLaiCorevalueIntroduction[language]);
	$('.WeiLaiDifference').html(WeiLaiDifference[language]);
	$('.WeiLaiDifference1').html(WeiLaiDifference1[language]);
	$('.WeiLaiDifference2').html(WeiLaiDifference2[language]);
	$('.WeiLaiDifference3').html(WeiLaiDifference3[language]);
	$('.WeiLaiDifference4').html(WeiLaiDifference4[language]);
	$('.WeiLaiDifference5').html(WeiLaiDifference5[language]);
	$('.WeiLaiDifference6').html(WeiLaiDifference6[language]);
	$('.WeiLaiDifference5Info').html(WeiLaiDifference5Info[language]);
	$('.WeiLaiDifference6Info').html(WeiLaiDifference6Info[language]);
	$('.commonLvyue1').html(commonLvyue1[language]);
	$('.Leadership').html(Leadership[language]);
	$('.TalentRecruitment').html(TalentRecruitment[language]);
	$('.WeiLaiBuildingaboutfbType1').html(homePageSwiperFourDesignideaInfo2[language]);
	$('.WeiLaiBuildingaboutfbType3').html(homePageSwiperFourTourismVacationSocialBusiness[language]);
	$('.floralReservation').html(floralReservation[language]);
	$('.commonBaina').html(commonBaina[language]);
	$('.commonBanlan').html(commonBanlan[language]);

/***/ }

});


/** WEBPACK FOOTER **
 ** js/weiLai.94cf8b3f.js
 **/